/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNull } from '../../factoriesAny.js';
export var nullDependencies = {
  createNull
};